import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useLazyGetServiceListQuery } from "features/service/api/serviceListApi";

/** Сервисов немного, поэтому тянем их одной страницей и ищем нужный локально. */
const SERVICE_PAGE = { page: 1, size: 200 };

/** Локализованное название текущего сервиса; если его нет — код сервиса. */
export function useServiceTitle(serviceCode?: string): string {
  const { i18n } = useTranslation();
  const [fetchServices, { data }] = useLazyGetServiceListQuery();

  useEffect(() => {
    fetchServices(SERVICE_PAGE);
  }, [fetchServices]);

  const currentService = useMemo(() => {
    if (!serviceCode || !data?.res?.content) return null;
    return data.res.content.find((s) => String(s.code) === String(serviceCode));
  }, [serviceCode, data]);

  const title =
    currentService &&
    (i18n.language?.startsWith("ky")
      ? currentService.nameKy
      : currentService.nameRu);

  return title || serviceCode || "Сервис";
}
